import { Trans } from 'react-i18next';
import React, { memo } from 'react';

import { getTermsOfUse, getRefundPolicy, getPrivacyPolicy } from 'constants/general/policy';

import { getProjectEmail } from 'helpers/other/commonUtils';

import { Text } from 'libComponents';
import Logo from 'components/Logo';

import styles from './Footer.module.css';

interface IFooterProps {
    isStartPage?: boolean;
}

function Footer({ isStartPage }: IFooterProps) {
    const startPageFooter = (
        <footer className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.footerTitle}>
                    <Text type="small-text" color="text-secondary-subdued">
                        <Trans i18nKey="Muscle Booster Workout Planner" />
                    </Text>
                </div>
                <div className={styles.linkBox}>
                    <a
                        className={styles.link}
                        rel="noopener noreferrer"
                        target="_blank"
                        href={getPrivacyPolicy()}
                        data-locator="privacyPolicyLink"
                    >
                        <Trans i18nKey="Privacy Policy" />
                    </a>
                    <a
                        className={styles.link}
                        rel="noopener noreferrer"
                        target="_blank"
                        href={getTermsOfUse()}
                        data-locator="termsOfUseLink"
                    >
                        <Trans i18nKey="Terms of Use" />
                    </a>
                    <a
                        className={styles.link}
                        rel="noopener noreferrer"
                        target="_blank"
                        href={getRefundPolicy()}
                        data-locator="refundPolicyLink"
                    >
                        <Trans i18nKey="Refund policy" />
                    </a>
                    <a className={styles.link} href={'mailto:' + getProjectEmail()}>
                        <Trans i18nKey="Contact Us" />
                    </a>
                </div>
            </div>
        </footer>
    );

    const defaultFooter = (
        <footer className={styles.defaultFooter}>
            <Logo footerLogo />
            <Text type="caption" color="text-secondary-subdued">
                <Trans i18nKey="Change yourself" />
            </Text>
        </footer>
    );

    return isStartPage ? startPageFooter : defaultFooter;
}

export default memo(Footer);
